import { fromJS } from "immutable";

const avatarList = fromJS([
  {
    id: "1",
    avatar: `images/avatar1.png`,
  },
  {
    id: "2",
    avatar: `images/avatar2.png`,
  },
  {
    id: "3",
    avatar: `images/avatar3.png`,
  },
  {
    id: "4",
    avatar: `images/avatar4.png`,
  },
  {
    id: "5",
    avatar: `images/avatar5.png`,
  },
  {
    id: "6",
    avatar: `images/avatar6.png`,
  },
]);

export default avatarList;
